module.exports = __webpack_public_path__ + "static/media/billiards.11ffa267.webp";